import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Reveal, MaskedLine, Kicker } from "@/components/Reveal";

export default function PageHero({ kicker, title, accent, sub, crumb }) {
    return (
        <section className="noise-overlay relative overflow-hidden bg-[#0F0F23] pb-16 pt-36 sm:pb-20 sm:pt-44">
            <div className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-[#C8102E]/20 blur-[120px]" />
            <div className="absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-[#FFA200]/10 blur-[100px]" />
            <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
                <Reveal>
                    <Kicker>{kicker}</Kicker>
                </Reveal>
                <h1 className="font-display mt-5 text-4xl font-black tracking-tight text-white sm:text-5xl lg:text-6xl">
                    <MaskedLine delay={0.1}>{title}</MaskedLine>
                    {accent && (
                        <MaskedLine delay={0.22} className="text-[#C8102E]">
                            {accent}
                        </MaskedLine>
                    )}
                </h1>
                {sub && (
                    <Reveal delay={0.35}>
                        <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#9999BB] sm:text-lg">{sub}</p>
                    </Reveal>
                )}
                <Reveal delay={0.45}>
                    <nav className="mt-6 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] text-[#666688]" data-testid="breadcrumb">
                        <Link to="/" className="transition-colors hover:text-[#FFA200]">Home</Link>
                        <ChevronRight size={12} />
                        <span className="text-[#FFA200]">{crumb}</span>
                    </nav>
                </Reveal>
            </div>
        </section>
    );
}
